import * as React from 'react';

export interface SelectedProductContextValue {
  selectedItemNumber?: string;
  setSelectedItemNumber: (itemNumber?: string) => void;
  selectedPreferenceCode?: string;
  setSelectedPreferenceCode: (preferenceCode?: string) => void;
}

export const SelectedProductContext = React.createContext<SelectedProductContextValue>({
  selectedItemNumber: undefined,
  setSelectedItemNumber: () => undefined,
  selectedPreferenceCode: undefined,
  setSelectedPreferenceCode: () => undefined,
});

export const SelectedProductProvider: React.FunctionComponent = ({children}) => {
  const [selectedItemNumber, setSelectedItemNumber] = React.useState<string>();
  const [selectedPreferenceCode, setSelectedPreferenceCode] = React.useState<string>();

  return (
    <SelectedProductContext.Provider
      value={{selectedItemNumber, setSelectedItemNumber, selectedPreferenceCode, setSelectedPreferenceCode}}
    >
      {children}
    </SelectedProductContext.Provider>
  );
};

export const useSelectedProduct = (): SelectedProductContextValue => React.useContext(SelectedProductContext);
